<template>
  <div class="container">
    <div class="meet-page trans">
      <meet-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view> -->
      <div class="main">
        <div class="meet-list">
          <div class="meet-item shadow" v-for="item in meetList" :key="item.id">
            <div class="item-left">
              <img class="item-img" :src="item.imgUrl" alt="" />
              <h2 class="item-tit">{{ item.title }}</h2>
            </div>
            <div class="more" @click="handleDetails(item.id)">查看详情</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import meetHeader from "@/components/header"
  import axios from "@/interceptor"
  import CurrentConferenceMixin from "@/mixin/CurrentConference"

  export default {
    name: "visitPage",
    mixins: [ CurrentConferenceMixin ],
    components: {
      meetHeader,
    },

    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "会议信息",
        },

        meetList: [
          {
            id: 1,
            title: "会议概况",
            imgUrl: require("@/assets/img/meet-icon1.png"),
          },
          {
            id: 2,
            title: "会议通知",
            imgUrl: require("@/assets/img/meet-icon2.png"),
          },
          {
            id: 3,
            title: "参会须知",
            imgUrl: require("@/assets/img/meet-icon3.png"),
          },
          {
            id: 4,
            title: "会场信息",
            imgUrl: require("@/assets/img/meet-icon4.png"),
          },
          {
            id: 5,
            title: "酒店信息",
            imgUrl: require("@/assets/img/meet-icon5.png"),
          },
          {
            id: 6,
            title: "会议日程",
            imgUrl: require("@/assets/img/meet-icon6.png"),
          },
          {
            id: 7,
            title: "会务安排",
            imgUrl: require("@/assets/img/meet-icon7.png"),
          },
          //2020.06.21关闭魅力北京
          //{id: 8, title:"魅力北京", imgUrl: require('@/assets/img/meet-icon8.png')}
        ],
        conference: {
          address: "1",
          affairs: [],
          cbcompany: "1",
          content: "",
          date: null,
          file_metadata: null,
          guests: [],
          hotels: [],
          schedules: [],
          id: 5,
          informs: [],
          liveurl: "",
          note: "",
          notices: [],
          price: 0,
          projects: [],
          sites: [],
          status: "",
          surveyurl: "",
          title: "",
          treatisereq: [],
          xbcompany: "",
          zbcompany: "",
        },
      }
    },
    created() {
      this.getConference()
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },

      handleDetails(id) {
        if (id == 1) {
          this.$router.push({
            name: "meetlevel",
            params: { conference: this.conference },
          })
        } else if (id == 2) {
          this.$router.push({
            name: "meetinformlist",
            params: { noticelist: this.conference.informs },
          })
        } else if (id == 3) {
          this.$router.push({
            name: "meetnoticelist",
            params: { noticelist: this.conference.notices },
          })
        } else if (id == 4) {
          this.$router.push({
            name: "meetsitelist",
            params: { noticelist: this.conference.sites },
          })
        } else if (id == 5) {
          this.$router.push({
            name: "meethotellist",
            params: { noticelist: this.conference.hotels },
          })
        } else if (id == 6) {
          this.$router.push({
            name: "meetagendalist",
            params: { noticelist: this.conference.schedules },
          })
        } else if (id == 7) {
          this.$router.push({
            name: "meetaffairlist",
            params: { noticelist: this.conference.affairs },
          })
        } else {
          this.$router.push("/meetLevel")
        }
      },
      async getConference() {
        await this.$store.dispatch("conference/getCurrentConference")
        // 取当前会议
        this.conference = this.currentConference
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .meet-list {
      width: 100%;

      .meet-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;
        border-radius: 5px;
        padding: 15px;
        box-sizing: border-box;

        .item-left {
          display: flex;
          align-items: center;
        }

        .item-img {
          width: 50px;
        }

        .item-tit {
          font-size: 18px;
          margin-left: 15px;
          font-weight: bold;
          color: var(--main-color);
        }

        .more {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
</style>
